/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const taskList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 480px;
`;
